<form class="m-1">
    <div class="row">
        <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Filiale :
                <span class="required_champs">*</span>
            </label>
            <ng-select *ngIf="isDetailMode" [(ngModel)]="filiale_id" (change)="load_filiale_data()" [disabled]="true"
                placeholder="Choisissez " name="filiale_id" id="filiale_id" [multiple]="false"
                [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsFiliale" [value]="item.id">{{ item?.libelle }}
                </ng-option>
            </ng-select>
        </div> -->


        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Code:
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input  class="form-control custom-input" [disabled]="itemSouscripteur.id || isDetailMode" placeholder="Code"
                autocomplete="off" [(ngModel)]="itemSouscripteur.code" name="code" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Codification:
                <span class="required_champs">*</span>
            </label>
            <input [disabled]="isDetailMode"  class="form-control custom-input" placeholder="Codification" autocomplete="off"
                [(ngModel)]="itemSouscripteur.codification" name="codification" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Type:
                <span class="required_champs">*</span>
            </label>
            <ng-select [disabled]="isDetailMode" (change)="onChangeTypeSouscripteur()" [(ngModel)]="itemSouscripteur.type_souscripteur_id" placeholder="Choisissez " name="type_souscripteur_id"
                id="type_souscripteur_id" [multiple]="false" [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsTypeSouscripteur" [value]="item.id">{{ item?.libelle }}
                </ng-option>
            </ng-select>
        </div>
        <div *ngIf="itemSouscripteur.type_souscripteur_code == 'ENT'" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Libellé:
                <span class="required_champs">*</span>
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                [(ngModel)]="itemSouscripteur.libelle" name="libelle" autocomplete="off" type="text" />
        </div>
        <div *ngIf="itemSouscripteur.type_souscripteur_code == 'INDIV'" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Nom :
                <span class="required_champs">*</span>
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Nom" autocomplete="off"
                [(ngModel)]="itemSouscripteur.nom" name="nom" autocomplete="off" type="text" />
        </div>
        <div *ngIf="itemSouscripteur.type_souscripteur_code == 'INDIV'" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Prenom :
                <span class="required_champs">*</span>
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Prenom" autocomplete="off"
                [(ngModel)]="itemSouscripteur.prenom" name="prenom" autocomplete="off" type="text" />
        </div>
        

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Ville :
                <span class="required_champs">*</span>
            </label>
            <ng-select [disabled]="isDetailMode" [(ngModel)]="itemSouscripteur.ville_id" placeholder="Choisissez " name="ville_id" id="ville_id"
                [multiple]="false" [closeOnSelect]="true">
                <ng-option *ngFor="let item of itemsVille" [value]="item.id">{{ item?.libelle }}
                </ng-option>
            </ng-select>
        </div>


        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Email :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Email" autocomplete="off"
                [(ngModel)]="itemSouscripteur.email" name="email" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Boite postale :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Boite postale" autocomplete="off"
                [(ngModel)]="itemSouscripteur.boite_postale" name="boite_postale" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Numéro compte bancaire :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Compte bancaire" autocomplete="off"
                [(ngModel)]="itemSouscripteur.numero_compte" name="numero_compte" autocomplete="off"
                type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Téléphone :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Téléphone" autocomplete="off"
                [(ngModel)]="itemSouscripteur.telephone" name="telephone" autocomplete="off" type="text" mask="00-00-00-00-00" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Fax :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Fax" autocomplete="off"
                [(ngModel)]="itemSouscripteur.fax" name="fax" autocomplete="off" type="text" mask="00-00-00-00-00" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Image :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <!-- <input [disabled]="isDetailMode" (change)="uploadFile($event)" class="form-control custom-input" autocomplete="off"
                name="image" autocomplete="off" type="file" /> -->
                <!-- <input type="text" [src]="itemSouscripteur.image_url" name="" id=""> -->
                <img style="width: 100px;height: 100px;" [src]="itemSouscripteur.image_url" alt="">
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Adresse :
                <!-- <span class="required_champs">*</span> -->
            </label>
            <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Adresse" autocomplete="off"
                [(ngModel)]="itemSouscripteur.adresse" name="adresse" autocomplete="off" type="text" />
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <input [disabled]="isDetailMode" [(ngModel)]="itemSouscripteur.is_prorata_prime"
                                id="is_prorata_prime" name="is_prorata_prime"
                                autocomplete="off" type="checkbox" />
                            <label for="is_prorata_prime">Prorata prime?
                            </label>
                          
                            <ng-select [disabled]="isDetailMode" *ngIf="itemSouscripteur.is_prorata_prime" [(ngModel)]="itemSouscripteur.mode_prorata_id" placeholder="Choisissez mode prorata "
                                name="mode_prorata_id" id="statut_garant_id" [multiple]="false" [closeOnSelect]="true">
                                <ng-option *ngFor="let item of itemsModeProrata" [value]="item.id">{{ item.libelle }}
                                </ng-option>
                            </ng-select>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
            <input [disabled]="isDetailMode" [(ngModel)]="itemSouscripteur.is_attente_prealable_acte_visible"
                                id="is_attente_prealable_acte_visible" name="is_attente_prealable_acte_visible"
                                autocomplete="off" type="checkbox" />
                            <label for="is_attente_prealable_acte_visible">Acte entente préalable visible?
                            </label>

                            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
            <input [disabled]="isDetailMode" [(ngModel)]="itemSouscripteur.is_non_garantie_acte_visible"
                                id="is_non_garantie_acte_visible" name="is_non_garantie_acte_visible"
                                autocomplete="off" type="checkbox" />
                            <label for="is_non_garantie_acte_visible">Actes non garantis visibles?
                            </label>

                            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
            <input [disabled]="isDetailMode" [(ngModel)]="itemSouscripteur.is_attente_prealable_medoc_visible"
                                id="is_attente_prealable_medoc_visible" name="is_attente_prealable_medoc_visible"
                                autocomplete="off" type="checkbox" />
                            <label for="is_attente_prealable_medoc_visible">Médoc entente préalable visible?
                            </label>

                            
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1" style="padding-left: 5px; padding-right: 5px">
            <input [disabled]="isDetailMode" [(ngModel)]="itemSouscripteur.is_non_garantie_medoc_visible"
                                id="is_non_garantie_medoc_visible" name="is_non_garantie_medoc_visible"
                                autocomplete="off" type="checkbox" />
                            <label for="is_non_garantie_medoc_visible">Médoc non garantie visible?
                            </label>

                            
        </div>
       
    </div>
</form>